export default __webpack_public_path__ + "static/DesktopMediaMainBanner-92a84907016246d48a4b9dacb151eb50.png";